import React, { useEffect, useState } from "react";

import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import { ValidationBannerProps } from "./ValidationBanner.model";

import "@companion-core/web/src/Assets/Styles/scss/validationBanner.scss";

export const ValidationBanner = ({
  type,
  text = "",
  className,
  visible = true,
  autoFadeOut,
  fadeOutDelay = 5000,
  testID,
  onDisapear,
}: ValidationBannerProps) => {
  const [isVisible, setIsVisible] = useState(visible);

  useEffect(() => {
    setIsVisible(visible);
    let timeOut: NodeJS.Timeout;
    if (autoFadeOut) {
      timeOut = setTimeout(() => {
        setIsVisible(false);
        onDisapear && onDisapear();
      }, fadeOutDelay);
    }
    return () => clearTimeout(timeOut);
  }, [visible]);

  const icons = {
    "success": "JP-Circle-check",
    "error": "JP-Circle-close",
  };

  return (
    isVisible && (
      <div
        className={`body-text-9 validation-banner validation-banner--${type} ${className ?? ""}`}
        data-testid={testID}>
        <div className="validation-banner__content">
          <FontIcon name={icons[type]} size={16} className="validation-banner__icon" />
          {text}
        </div>
      </div>
    )
  );
};
